import VideoPlayer from "./videoPlayer";

export default VideoPlayer;